import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import { Home, QrCode2, Menu } from "@mui/icons-material";

export const Bottombar = (props) => {
  const [value, setValue] = useState(props.value);
  const navigate = useNavigate();

  useEffect(() => {
    if(value === 0){
      navigate("/home")
    } else if(value === 1) {
      navigate("/generateticket")
    } else if(value === 2) {
      navigate("/more")
    }
    
  }, [value]);

  return (
    <Box sx={{
      position: 'fixed',
        bottom: 0,
        zIndex: 3,
        display: { xs: "block", sm: "none"},
        width: '100%'
    }}>
      <BottomNavigation
      showLabels
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
    >
      <BottomNavigationAction label="Home" icon={<Home />} />
      <BottomNavigationAction label="Digital ticket" icon={<QrCode2 />} />
      <BottomNavigationAction label="More" icon={<Menu />} /> 
    </BottomNavigation>
    </Box>
  );
};
